import Dialog from "components/dialog";

import { FiX } from "react-icons/fi";
import { secondsDiff, humanizedTime } from "utils/date";
import dayjs from "dayjs";

import { useState, useEffect } from "react";

export default function TestModeInfo(props) {
  const { questionnaire, loading } = props;
  const { onComplete, onCancel } = props;

  const [timeLeft, setTimeLeft] = useState(humanizedTimeLeft());
  const [showCancelDialog, setShowCancelDialog] = useState(false);

  useEffect(() => {
    if (!questionnaire?.seriousFrom) return;

    const interval = setInterval(() => {
      setTimeLeft(humanizedTimeLeft());
      const startTime = dayjs(questionnaire.seriousFrom);
      const finalTime = startTime.add(questionnaire.totalTime, "minutes");
      const diff = secondsDiff(new Date(), finalTime);
      if (diff >= 0) return;

      clearInterval(interval);
      onComplete();
    }, 1000);
    return () => clearInterval(interval);
  }, [questionnaire]);

  function humanizedTimeLeft() {
    if (!questionnaire?.seriousFrom) return;

    const secondsLeft =
      questionnaire.totalTime * 60 -
      secondsDiff(questionnaire.seriousFrom, new Date());
    return humanizedTime(secondsLeft);
  }

  function handleCancel() {
    onCancel().then(() => {
      setShowCancelDialog(false);
    });
  }

  if (!questionnaire?.seriousFrom || loading) return <></>;

  return (
    <>
      <div className="test-mode-wrapper bottom-[56px] md:bottom-[-2px] md:ml-[300px] fixed px-5 py-4 w-full bg-black-200">
        <div className="flex items-center justify-between">
          <div>
            <span className="text-white">Tempo restante</span>
            <span className="inline-block ml-2 text-white">{timeLeft}</span>
          </div>
          <div
            className="close-wrapper cursor-pointer"
            onClick={() => setShowCancelDialog(true)}
          >
            <FiX color="#666" size={20} />
          </div>
        </div>
      </div>

      {showCancelDialog && (
        <Dialog
          title="Cancelar modo prova?"
          confirmText="Cancelar modo prova"
          cancelText="Continuar no modo prova"
          onConfirm={handleCancel}
          onCancel={() => setShowCancelDialog(false)}
        >
          <p className="dialog-text">
            Você vai poder ver as respostas certas antes de terminar o simulado
            e não vai mais ter tempo limite para resolução.
          </p>
        </Dialog>
      )}

      <style jsx>{`
        @media (min-width: 768px) {
          .test-mode-wrapper {
            width: calc(100% - 539px);
          }
        }
      `}</style>
    </>
  );
}
